import React, { useState, useEffect } from 'react'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'

function DeliveryMethodSummary(props) {
    console.log(props.active)
    console.log(props.disabled)

    function onClick() {
        props.onClick()
    }

    return (
        <Box className={'delivery payment-method-summary' + (props.active ? ' active' : '') + (props.disabled ? ' disabled' : '')} onClick={() => onClick()}>
            <Grid container justifyContent='center' alignItems='center' spacing={2}>
                <Grid item xs={12}>
                    <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '1rem' }}>
                        {props.icon}
                    </Box>
                    <Box style={{marginBottom: '0.5rem'}}>
                        <h3>{props.title}</h3>
                    </Box>
                    <Box className='price'>
                        {props.subtext &&
                            <p>{props.subtext}</p>
                        }
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}

export default DeliveryMethodSummary